import { SchemaV02Adaptor } from './adaptor.js'

/**
 * Default instance for convenience
 */
export const schemaV02Adaptor = new SchemaV02Adaptor()
